import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_RECENT_POSTS } from '../../graphql/queries';

const TrendingV2 = () => {
    const publicUrl = process.env.PUBLIC_URL + '/';

    const { data, loading, error } = useQuery(GET_RECENT_POSTS, {
        variables: { first: 3 }
    });

    const posts = data?.posts?.nodes || [];

    // Helper function to format date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    };

    // Helper function to get excerpt
    const getExcerpt = (excerpt, maxLength = 120) => {
        if (!excerpt) return '';
        const text = excerpt.replace(/<[^>]*>/g, '');
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    // Helper function to get featured image URL
    const getFeaturedImage = (post, index) => {
        return post?.featuredImage?.node?.sourceUrl || publicUrl + `assets/img/post/${19 + index}.png`;
    };

    // Helper function to get first category
    const getFirstCategory = (post) => {
        return post?.categories?.nodes?.[0] || { name: 'Uncategorized', slug: 'uncategorized' };
    };

    // Helper function to get author name
    const getAuthorName = (post) => {
        return post?.author?.node?.name || 'Admin';
    };

    const tagColors = ['tag-light-green', 'tag-blue', 'tag-light-green', 'tag-blue'];

    if (loading) {
        return (
            <div className="tranding-area pd-top-75 pd-bottom-50">
                <div className="container">
                    <div className="section-title">
                        <h6 className="title">Trending News</h6>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <p>Loading...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        console.error('TrendingV2 Error:', error);
        return null;
    }

    return (
        <div className="tranding-area pd-top-75 pd-bottom-50">
            <div className="container">
                <div className="section-title">
                    <div className="row">
                        <div className="col-md-12">
                            <h6 className="title">Trending News</h6>
                        </div>
                    </div>
                </div>
                <div className="go-top">
                    <div className="row">
                        {posts.map((post, index) => {
                            const category = getFirstCategory(post);
                            const tagColor = tagColors[index % tagColors.length];

                            return (
                                <div className="col-lg-3 col-sm-6" key={post.id}>
                                    <div className="single-post-wrap">
                                        <div className="thumb">
                                            <img
                                                src={getFeaturedImage(post, index)}
                                                alt={post?.featuredImage?.node?.altText || post.title}
                                            />
                                        </div>
                                        <div className="details">
                                            <div className="post-meta-single mb-3">
                                                <ul>
                                                    <li>
                                                        <Link className={`tag-base ${tagColor}`} to="/cat-page">
                                                            {category.name}
                                                        </Link>
                                                    </li>
                                                    <li><i className="fa fa-clock-o" />{formatDate(post.date)}</li>
                                                </ul>
                                            </div>
                                            <h6>
                                                <Link
                                                    to={`/blog/${post.slug}`}
                                                    dangerouslySetInnerHTML={{ __html: post.title }}
                                                />
                                            </h6>
                                            <p>{getExcerpt(post.excerpt)}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrendingV2;
